import { string, func } from 'prop-types';
import { Button } from '@fff-web/fff-ui-shared';
import { UPGRADE_PAGE_URL } from '../../../../utils/constants';
import * as classNames from './UpsellCTA.module.css';

const UpsellCTA = ({ title, description, ctaLabel, onClick }) => (
  <div>
    <div className={classNames.upsellBox}>
      <div className={classNames.title}>{title}</div>
      <div className={classNames.description}>{description}</div>
    </div>
    <Button
      data-testid="upsell-cta"
      width="100%"
      onClick={(e) => {
        onClick(e);
        window.location = UPGRADE_PAGE_URL;
      }}
    >
      {ctaLabel}
    </Button>
  </div>
);

UpsellCTA.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  ctaLabel: string.isRequired,
  onClick: func.isRequired,
};

export default UpsellCTA;
